module.exports = __webpack_public_path__ + "img/bag_bw.fd487d60.jpg";